import { useContext } from 'react';
import { CharityListContext } from './charityContext';

export const useCharityList = () => {
    return useContext(CharityListContext);
};
